module.exports = __webpack_public_path__ + "media/application/images/svgs/git-branch-df6fec977a57de71bac9931f94c1f465.svg";